import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import { Box, IconButton, Tooltip } from '@mui/material';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

import projectLogo from '../../../assets/taytan-icon-clean/Icon-64.png';
import { useIsMobile } from '../../../utils/useScreenSize';

// image from rt-react
// const projectLogo =
//     'https://res.cloudinary.com/amadeus7/image/upload/v1600168006/react-platform/logoIcon.svg';

const sidebarHeaderStyles = makeStyles((theme) => {
    return {
        appSidebarHeader: (props) => {
            const { sidebarToggle } = props;

            return {
                height: theme.themeVars.headerHeight,
                width: theme.themeVars.sidebarWidth,
                display: 'flex',
                alignItems: 'center',
                background: theme.palette.common.white,
                paddingLeft: theme.themeVars.spacer,
                paddingRight: theme.themeVars.spacer,
                justifyContent: 'space-between',
                transition: theme.themeVars.transitionBase,
                ...(sidebarToggle
                    ? {
                          width: theme.themeVars.sidebarWidthCollapsed,
                          overflow: 'hidden'
                      }
                    : {})
            };
        },
        headerLogoWrapperBtn: {
            background: theme.palette.grey[100],
            color: theme.palette.grey[200]
        },
        headerLogoWrapper: (props) => {
            const { sidebarToggle } = props;
            return sidebarToggle
                ? {
                      margin: 'auto'
                  }
                : {};
        },
        headerLogoText: (props) => {
            const { sidebarToggle } = props;
            return sidebarToggle
                ? {
                      opacity: '0',
                      visibility: 'hidden',
                      overflow: 'hidden',
                      width: '0',
                      paddingLeft: '0'
                  }
                : {};
        },
        appSidebarHeaderBtn: (props) => {
            const { sidebarToggle } = props;

            return {
                transition: theme.themeVars.transitionBase,
                opacity: '1',
                visibility: 'visible',
                [theme.breakpoints.down('xl')]: {
                    display: 'none'
                },
                ...(sidebarToggle
                    ? {
                          opacity: '0',
                          visibility: 'hidden',
                          display: 'none'
                      }
                    : {})
            };
        },
        appSidebarHeaderBtnMobile: {
            display: 'none',
            [theme.breakpoints.down('xl')]: {
                display: 'block'
            }
        },
        appSidebarLogo: {
            height: '40px',
            width: 'auto'
        }
    };
});

const SidebarHeader = (props) => {
    const { setSidebarToggle, sidebarToggle } = props;
    const isMobile = useIsMobile();
    const classes = sidebarHeaderStyles({ sidebarToggle });

    return (
        <div className={classes.appSidebarHeader}>
            <Box
                className={classes.headerLogoWrapper}
                title="Taytan"
            >
                <Link to="/">
                    <IconButton color="primary" size="medium" className={classes.headerLogoWrapperBtn}>
                        <img
                            className={classes.appSidebarLogo}
                            alt="Taytan"
                            src={projectLogo}
                        />
                    </IconButton>
                </Link>
            </Box>
            <Box className={classes.appSidebarHeaderBtn}>
                <Tooltip title="Toggle Sidebar" placement="right">
                    <IconButton color="inherit" onClick={setSidebarToggle} size="medium">
                        {sidebarToggle ? <MenuRoundedIcon /> : <MenuOpenRoundedIcon />}
                    </IconButton>
                </Tooltip>
            </Box>
            <Box className={classes.appSidebarHeaderBtnMobile}>
                <Tooltip title="Toggle Sidebar" placement="right">
                    <IconButton color="inherit" onClick={setSidebarToggle} size="medium">
                        {sidebarToggle && isMobile ? <MenuOpenRoundedIcon /> : <MenuRoundedIcon />}
                    </IconButton>
                </Tooltip>
            </Box>
        </div>
    );
};

SidebarHeader.propTypes = {
    setSidebarToggle: PropTypes.func.isRequired,
    sidebarToggle: PropTypes.bool.isRequired
};

export default SidebarHeader;
